interface adSlotPrebid {
    appnexus: appnexusPlacementId,
    pubmatic: pubmaticFormat,
    freewheel: freewheelFormat,
    fw: fwFormat,
    pubmatic_apex: pubmaticFormat,
    taboola: taboolaFormat,
    improve: improveFormat,
    rubicon: rubiconFormat,
    seedtag: seedtagFormat,
    ix: ixFormat,
    criteo: criteoFormat,
    mobkoi: mobkoiFormat,
    yobee: yobeeFormat,
    ogury: oguryFormat,
    pubstack: pubstackFormat,
    missena: missenaFormat,
    ttd: ttdFormat
}

interface ttdFormat {
    display: any,
    video: any
}
interface missenaFormat {
    display: any,
}
interface pubstackFormat {
    display: any
    video: any
}

interface taboolaFormat {
    display: any
}
interface mobkoiFormat {
    display: any,
}
interface seedtagFormat {
    display: any,
    video: any
}

interface ixFormat {
    display: any,
    video: any
}

interface criteoFormat {
    display: any,
    video: any
}

interface rubiconFormat {
    display: any,
    video: any
}
interface improveFormat {
    video: any
}

interface appnexusPlacementId {
    display: any
    video: any
    code: any
}

interface yobeeFormat {
    display: any,
    video: any
}

interface pubmaticFormat {
    display: any,
    video: any
}

interface freewheelFormat {
    zoneId: Record<string, string>;
}

interface fwFormat {
    video: any
}

interface oguryFormat {
    display: any
}
export interface psConf {
    siteID: string
    tag: string
}



//overlayer appnexus

export const pubStackConf: Record<string, psConf> = {
    fanpage: {
        siteID: '32e5a79f-7bbf-4843-90f8-9736c88edf91',
        tag: 'https://boot.pbstck.com/v1/tag/32e5a79f-7bbf-4843-90f8-9736c88edf91'
    },
    ck_it: {
        siteID: '280ed8f2-1236-433e-a847-d09885cd4581',
        tag: 'https://boot.pbstck.com/v1/tag/280ed8f2-1236-433e-a847-d09885cd4581'
    },
    ck_wow: {
        siteID: '32e5a79f-7bbf-4843-90f8-9736c88edf91',
        tag: 'https://boot.pbstck.com/v1/tag/32e5a79f-7bbf-4843-90f8-9736c88edf91'
    },
    geopop: {
        siteID: 'd67d6fbd-2c33-4c5f-a752-50636d497873',
        tag: 'https://boot.pbstck.com/v1/tag/d67d6fbd-2c33-4c5f-a752-50636d497873'
    }
}

export const adSlotPrebid: adSlotPrebid = {
    freewheel: {
        zoneId: {
            fanpage_video: '33905290',
            ck_it_video: '33905292',
            geopop_video: '33905308',
            ck_wow_video: '33905294',
            ohga_video: '33905312',
            kodami_video: '33905310',
            wamily_video: '33905290',
            lexplain_video: '33905314'
        }
    },
    fw: {
        video: {
            fanpage_video: {
                siteSectionId: '3456217',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',
            },
            ck_it_video: {
                siteSectionId: '23498488',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',

            },
            geopop_video: {
                siteSectionId: '23498490',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',

            },
            ck_wow_video: {
                siteSectionId: '23498489',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',

            },
            kodami_video: {
                siteSectionId: '23498487',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',

            },
            wamily_video: {
                siteSectionId: '3456217',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',

            },
            lexplain_video: {
                siteSectionId: '23498491',
                networkId: '536054',
                profile: '536054:fw_ssp_prebidjs_ciaopeoplenetwork',

            }
        }

    },
    missena: {
        display: {
            go_interstitial: {
                apiKey: 'PA-57557322',
                gpid: '/1010633/go_interstitial',
                placement: "prestitial",
            },
            fpmobile_leadeboard: {
                apiKey: 'PA-57557322',
                gpid: '/1010633/fpmobile_leadeboard',
                placement: "infeed.s",
            },
            geopop_leaderboard: {
                apiKey: 'PA-95333687',
                gpid: '/1010633/geopop_leaderboard',
                placement: "infeed.s",
            },
            ck_it_mobile_leadeboard: {
                apiKey: 'PA-81815522',
                gpid: '/1010633/cookist_it_mobile_leadeboard',
                placement: "infeed.s",
            },
            ckmobile_leaderboard: {
                apiKey: 'PA-93288917',
                gpid: '/1010633/ckmobile_leaderboard',
                placement: "infeed.s",
            },
            lexplain_leaderboard: {
                apiKey: 'PA-57857748',
                gpid: '/1010633/lexplain_leaderboard',
                placement: "infeed.s",

            },
        }
    },

    ttd: {

        display: {
            fanpage_inarticle: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fanpage_inarticle"
            },
            cookist_it_inarticle: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/cookist_it_inarticle"
            },
            geopop_inarticle: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_inarticle"
            },
            fpmobile_leadeboard: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fpmobile_leadeboard"
            },
            fpmobile_300x250_top: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fpmobile_300x250_top"
            },
            fpmobile_300x250: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fpmobile_300x250"
            },
            fpmobile_fplayer: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fpmobile_fplayer"
            },
            fpmobile_300x250_bottom: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fpmobile_300x250_bottom"
            },
            ck_it_mobile_leadeboard: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_leadeboard"
            },
            ck_it_mobile_300x250_top: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_300x250_top"
            },
            ck_it_mobile_300x250: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_300x250"
            },
            ck_it_mobile_fplayer: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_fplayer"
            },
            ck_it_mobile_fplayer2: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_fplayer2"
            },
            ck_it_mobile_fplayer3: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_fplayer3"
            },
            ck_it_mobile_fplayer4: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_fplayer4"
            },
            ck_it_mobile_300x250_bottom: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_mobile_300x250_bottom"
            },
            ohga_header: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ohga_header"
            },
            ohga_300x250_top: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ohga_300x250_top"
            },
            ohga_300x250_middle: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ohga_300x250_middle"
            },
            ohga_low: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ohga_low"
            },
            ohga_bottom: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ohga_bottom"
            },
            geopop_leaderboard: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_leaderboard"
            },
            geopop_top: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_top"
            },
            geopop_middle: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_middle"
            },
            geopop_fplayer: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_fplayer"
            },
            geopop_fplayer2: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_fplayer2"
            },
            geopop_fplayer3: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_fplayer3"
            },
            geopop_fplayer4: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_fplayer4"
            },
            geopop_bottom: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_bottom"
            },
            ckmobile_leaderboard: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ckmobile_leaderboard"
            },
            ckmobile_300x250_top: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ckmobile_300x250_top"
            },
            ckmobile_300x250: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ckmobile_300x250"
            },
            ckmobile_fplayer: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ckmobile_fplayer"
            },
            ckmobile_300x250_bottom: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ckmobile_300x250_bottom"
            },
            kodami_header: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/kodami_header"
            },
            kodami_top: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/kodami_top"
            },
            kodami_middle: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/kodami_middle"
            },
            kodami_low: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/kodami_low"
            },
            kodami_bottom: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/kodami_bottom"
            }
        },
        video: {
            fanpage_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/fanpage_video"
            },
            ck_it_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_it_video"
            },
            ck_wow_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_wow_video"
            },
            ck_legal_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ck_legal_video"
            },
            ohga_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/ohga_video"
            },
            kodami_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/kodami_video"
            },
            geopop_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/geopop_video"
            },
            wamily_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/wamily_video"
            },
            lexplain_video: {
                supplySourceId: 'direct3yjkwp97',
                placementId: "/1010633/lexplain_video"
            }
        }
    },






    pubstack: {
        display: {
            go_interstitial: {
                adUnit: "go_interstitial"
            },
            fanpage_inarticle: {
                adUnit: "fanpage_inarticle"
            },
            cookist_it_inarticle: {
                adUnit: "cookist_it_inarticle"
            },
            geopop_inarticle: {
                adUnit: "geopop_inarticle"
            },
            fpmobile_leadeboard: {
                adUnit: "fpmobile_leadeboard"
            },
            fpmobile_300x250_top: {
                adUnit: "fpmobile_300x250_top"
            },
            fpmobile_300x250: {
                adUnit: "fpmobile_300x250"
            },
            fpmobile_fplayer: {
                adUnit: "fpmobile_fplayer"
            },
            fpmobile_300x250_bottom: {
                adUnit: "fpmobile_300x250_bottom"
            },
            ck_it_mobile_leadeboard: {
                adUnit: "ck_it_mobile_leadeboard"
            },
            ck_it_mobile_300x250_top: {
                adUnit: "ck_it_mobile_300x250_top"
            },
            ck_it_mobile_300x250: {
                adUnit: "ck_it_mobile_300x250"
            },
            ck_it_mobile_fplayer: {
                adUnit: "ck_it_mobile_fplayer"
            },
            ck_it_mobile_fplayer2: {
                adUnit: "ck_it_mobile_fplayer2"
            },
            ck_it_mobile_fplayer3: {
                adUnit: "ck_it_mobile_fplayer3"
            },
            ck_it_mobile_fplayer4: {
                adUnit: "ck_it_mobile_fplayer4"
            },
            ck_it_mobile_300x250_bottom: {
                adUnit: "ck_it_mobile_300x250_bottom"
            },
            ohga_header: {
                adUnit: "ohga_header"
            },
            ohga_300x250_top: {
                adUnit: "ohga_300x250_top"
            },
            ohga_300x250_middle: {
                adUnit: "ohga_300x250_middle"
            },
            ohga_low: {
                adUnit: "ohga_low"
            },
            ohga_bottom: {
                adUnit: "ohga_bottom"
            },
            geopop_leaderboard: {
                adUnit: "geopop_leaderboard"
            },
            geopop_top: {
                adUnit: "geopop_top"
            },
            geopop_middle: {
                adUnit: "geopop_middle"
            },
            geopop_fplayer: {
                adUnit: "geopop_fplayer"
            },
            geopop_fplayer2: {
                adUnit: "geopop_fplayer2"
            },
            geopop_fplayer3: {
                adUnit: "geopop_fplayer3"
            },
            geopop_fplayer4: {
                adUnit: "geopop_fplayer4"
            },
            geopop_bottom: {
                adUnit: "geopop_bottom"
            },
            ckmobile_leaderboard: {
                adUnit: "ckmobile_leaderboard"
            },
            ckmobile_300x250_top: {
                adUnit: "ckmobile_300x250_top"
            },
            ckmobile_300x250: {
                adUnit: "ckmobile_300x250"
            },
            ckmobile_fplayer: {
                adUnit: "ckmobile_fplayer"
            },
            ckmobile_300x250_bottom: {
                adUnit: "ckmobile_300x250_bottom"
            },
            kodami_header: {
                adUnit: "kodami_header"
            },
            kodami_top: {
                adUnit: "kodami_top"
            },
            kodami_middle: {
                adUnit: "kodami_middle"
            },
            kodami_low: {
                adUnit: "kodami_low"
            },
            kodami_bottom: {
                gpadUnitid: "kodami_bottom"
            }
        },
        video: {
            fanpage_video: {
                adUnit: "fanpage_video"
            },
            ck_it_video: {
                adUnit: "ck_it_video"
            },
            ck_wow_video: {
                adUnit: "ck_wow_video"
            },
            ck_legal_video: {
                adUnit: "ck_legal_video"
            },
            ohga_video: {
                adUnit: "ohga_video"
            },
            kodami_video: {
                adUnit: "kodami_video"
            },
            geopop_video: {
                adUnit: "geopop_video"
            },
            wamily_video: {
                adUnit: "wamily_video"
            },
            lexplain_video: {
                adUnit: "lexplain_video"
            }
        }
    },
    yobee: {
        display: {
            fanpage_inarticle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fanpage_inarticle"
            },
            cookist_it_inarticle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/cookist_it_inarticle"
            },
            geopop_inarticle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_inarticle"
            },
            fpmobile_leadeboard: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_leadeboard"
            },
            fpmobile_300x250_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_300x250_top"
            },
            fpmobile_300x250: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_300x250"
            },
            fpmobile_fplayer: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_fplayer"
            },
            fpmobile_300x250_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_300x250_bottom"
            },
            ck_it_mobile_leadeboard: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_leadeboard"
            },
            ck_it_mobile_300x250_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_300x250_top"
            },
            ck_it_mobile_300x250: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_300x250"
            },
            ck_it_mobile_fplayer: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_fplayer"
            },
            ck_it_mobile_fplayer2: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_fplayer2"
            },
            ck_it_mobile_fplayer3: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_fplayer3"
            },
            ck_it_mobile_fplayer4: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_fplayer4"
            },
            ck_it_mobile_300x250_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_300x250_bottom"
            },
            ohga_header: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_header"
            },
            ohga_300x250_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_300x250_top"
            },
            ohga_300x250_middle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_300x250_middle"
            },
            ohga_low: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_low"
            },
            ohga_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_bottom"
            },
            geopop_leaderboard: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_leaderboard"
            },
            geopop_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_top"
            },
            geopop_middle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_middle"
            },
            geopop_fplayer: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_fplayer"
            },
            geopop_fplayer2: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_fplayer2"
            },
            geopop_fplayer3: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_fplayer3"
            },
            geopop_fplayer4: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_fplayer4"
            },
            geopop_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_bottom"
            },
            ckmobile_leaderboard: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_leaderboard"
            },
            ckmobile_300x250_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_300x250_top"
            },
            ckmobile_300x250: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_300x250"
            },
            ckmobile_fplayer: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_fplayer"
            },
            ckmobile_300x250_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_300x250_bottom"
            },
            kodami_header: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_header"
            },
            kodami_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_top"
            },
            kodami_middle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_middle"
            },
            kodami_low: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_low"
            },
            kodami_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_bottom"
            }
        },
        video: {
            fanpage_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fanpage_video"
            },
            ck_it_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_video"
            },
            ck_wow_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_wow_video"
            },
            ck_legal_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_legal_video"
            },
            ohga_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_video"
            },
            kodami_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_video"
            },
            geopop_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_video"
            },
            wamily_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/wamily_video"
            },
            lexplain_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/lexplain_video"
            }
        }
    },
    appnexus: {
        code: {
            fanpage_video: 'fanpage.it_video',
            ck_it_video: 'cookist.it_video',
            ck_wow_video: 'cookist.com_video',
            ck_legal_video: 'cookist.com_video',
            ohga_video: 'ohga.it_video',
            kodami_video: 'kodami.it_video',
            geopop_video: 'geopop.it_video',
            wamily_video: 'fanpage.it_video',
            lexplain_video: 'fanpage.it_video',
        },
        display: {
            fanpage_inarticle: {
                placementId: 35179082,
                gpid: '/1010633/fanpage_inarticle'
            },
            cookist_it_inarticle: {
                placementId: 35282059,
                gpid: '/1010633/cookist_it_inarticle'
            },
            geopop_inarticle: {
                placementId: 35281646,
                gpid: '/1010633/geopop_inarticle'
            },
            ckmobile_300x250: {
                placementId: 12680661,
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_bottom: {
                placementId: 12680662,
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_300x250_top: {
                placementId: 24485986,
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_fplayer: {
                placementId: 12680663,
                gpid: '/1010633/ckmobile_fplayer'
            },
            ckmobile_leaderboard: {
                placementId: 12680664,
                gpid: '/1010633/ckmobile_leaderboard'
            },
            cookist_mobile_300x250_bottom: {
                placementId: 12680672,
                gpid: '/1010633/cookist_mobile_300x250_bottom'
            },
            cookist_mobile_300x250: {
                placementId: 12680671,
                gpid: '/1010633/cookist_mobile_300x250'
            },
            cookist_mobile_leaderboard: {
                placementId: 12680673,
                gpid: '/1010633/cookist_mobile_leaderboard'
            },
            ck_it_mobile_300x250: {
                placementId: 17835634,
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_bottom: {
                placementId: 17835635,
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            ck_it_mobile_300x250_top: {
                placementId: 17835633,
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                placementId: 17835636,
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                placementId: 17835639,
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            cookist_it_mobile_300x250: {
                placementId: 17835640,
                gpid: '/1010633/cookist_it_mobile_300x250'
            },
            cookist_it_mobile_300x250_bottom: {
                placementId: 17835642,
                gpid: '/1010633/cookist_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_leaderboard: {
                placementId: 17835643,
                gpid: '/1010633/cookist_it_mobile_leaderboard'
            },
            fpmobile_300x250: {
                placementId: 12680682,
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_bottom: {
                placementId: 12680683,
                gpid: '/1010633/fpmobile_300x250_bottom'
            },
            fpmobile_300x250_top: {
                placementId: 16638781,
                gpid: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_fplayer: {
                placementId: 12680684,
                gpid: '/1010633/fpmobile_fplayer'
            },
            fpmobile_leadeboard: {
                placementId: 12680685,
                gpid: '/1010633/fpmobile_leadeboard'
            },
            geopop_bottom: {
                placementId: 22777855,
                gpid: '/1010633/geopop_bottom'
            },
            geopop_fplayer: {
                placementId: 22777856,
                gpid: '/1010633/geopop_fplayer'
            },
            geopop_leaderboard: {
                placementId: 22777853,
                gpid: '/1010633/geopop_leaderboard'
            },
            geopop_middle: {
                placementId: 22777854,
                gpid: '/1010633/geopop_middle'
            },
            geopop_top: {
                placementId: 22777849,
                gpid: '/1010633/geopop_top'
            },
            go_interstitial: {
                placementId: 24514163,
                gpid: '/1010633/go_interstitial',
                instl: 1
            },
            //kodami_overlayer: {
            //    placementId: 35463873,
            //    gpid: '/1010633/kodami_overlayer'
            //},
            kodami_bottom: {
                placementId: 20791657,
                gpid: '/1010633/kodami_bottom'
            },
            kodami_header: {
                placementId: 20791624,
                gpid: '/1010633/kodami_header'
            },
            kodami_low: {
                placementId: 20791653,
                gpid: '/1010633/kodami_low'
            },
            kodami_middle: {
                placementId: 20791644,
                gpid: '/1010633/kodami_middle'
            },
            kodami_top: {
                placementId: 20791626,
                gpid: '/1010633/kodami_top'
            },
            Lexplain_bottom: {
                placementId: 30100306,
                gpid: '/1010633/Lexplain_bottom'
            },
            Lexplain_fplayer: {
                placementId: 30100304,
                gpid: '/1010633/Lexplain_fplayer'
            },
            Lexplain_leaderboard: {
                placementId: 30100305,
                gpid: '/1010633/Lexplain_leaderboard'
            },
            Lexplain_middle: {
                placementId: 30100303,
                gpid: '/1010633/Lexplain_middle'
            },
            Lexplain_top: {
                placementId: 30088229,
                gpid: '/1010633/Lexplain_top'
            },
            ohga_300x250_middle: {
                placementId: 14194519,
                gpid: '/1010633/ohga_300x250_middle'
            },
            ohga_300x250_top: {
                placementId: 14194517,
                gpid: '/1010633/ohga_300x250_top'
            },
            ohga_bottom: {
                placementId: 18288318,
                gpid: '/1010633/ohga_bottom'
            },
            ohga_header: {
                placementId: 14194515,
                gpid: '/1010633/ohga_header'
            },
            ohga_low: {
                placementId: 24485693,
                gpid: '/1010633/ohga_low'
            },
        },
        video: {
            fanpage_video: {
                placementId: 12957535,
                gpid: '/1010633/fanpage_video'
            },
            ck_it_video: {
                placementId: 17835664,
                gpid: '/1010633/ck_it_video'
            },
            geopop_video: {
                placementId: 22777858,
                gpid: '/1010633/geopop_video'
            },
            ck_wow_video: {
                placementId: 13108461,
                gpid: '/1010633/ck_wow_video'
            },
            ohga_video: {
                placementId: 14194524,
                gpid: '/1010633/ohga_video'
            },
            kodami_video: {
                placementId: 20791665,
                gpid: '/1010633/kodami_video'
            },
            wamily_video: {
                placementId: 12957535,
                gpid: '/1010633/wamily_video'
            },
            lexplain_video: {
                placementId: 12957535,
                gpid: '/1010633/lexplain_video'
            }
        }

    },
    mobkoi: {
        display: {
            ck_it_mobile_fplayer: {
                placementId: 'F5FFF769',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer2: {
                placementId: 'A58DC887',
                gpid: '/1010633/ck_it_mobile_fplayer2'
            },
            ck_it_mobile_fplayer3: {
                placementId: 'A58DC887',
                gpid: '/1010633/ck_it_mobile_fplayer3'
            },
            ck_it_mobile_fplayer4: {
                placementId: 'F5FFF769',
                gpid: '/1010633/ck_it_mobile_fplayer4'
            },
            ck_it_mobile_300x250: {
                placementId: 'A58DC887',
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_bottom: {
                placementId: 'A58DC887',
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            ck_it_mobile_300x250_top: {
                placementId: 'F5FFF769',
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            cookist_it_inarticle: {
                placementId: 'A58DC887',
                gpid: '/1010633/cookist_it_inarticle'
            },
            ckmobile_300x250: {
                placementId: 'F1C6C071',
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_top: {
                placementId: 'F93D37A2',
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_300x250_bottom: {
                placementId: 'F93D37A2',
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_fplayer: {
                placementId: 'F93D37A2',
                gpid: '/1010633/ckmobile_fplayer'
            },
            geopop_middle: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/geopop_middle'
            },
            geopop_bottom: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/geopop_bottom'
            },
            geopop_fplayer: {
                placementId: 'F93D37A2',
                gpid: '/1010633/geopop_fplayer'
            },
            ckmobile_fplayer2: {
                placementId: 'A52D20ED',
                gpid: '/1010633/ckmobile_fplayer2'
            },
            ckmobile_fplayer3: {
                placementId: 'A52D20ED',
                gpid: '/1010633/ckmobile_fplayer3'
            },
            ckmobile_fplayer4: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/ckmobile_fplayer4'
            },
            geopop_top: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/geopop_top'
            },
            geopop_inarticle: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/geopop_inarticle'
            },
            fanpage_inarticle: {
                placementId: 'DEFA3CDA',
                gpid: '/1010633/fanpage_inarticle'
            },
            fpmobile_300x250: {
                placementId: 'DEFA3CDA',
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_top: {
                placementId: 'C680A2D5',
                gpid: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_300x250_bottom: {
                placementId: 'C680A2D5',
                gpid: '/1010633/fpmobile_300x250_bottom'
            },
            fpmobile_fplayer: {
                placementId: 'C680A2D5',
                gpid: '/1010633/fpmobile_fplayer'
            },
            kodami_middle: {
                placementId: 'F8D3D235',
                gpid: '/1010633/kodami_middle'
            },
            kodami_bottom: {
                placementId: 'F8D3D235',
                gpid: '/1010633/kodami_bottom'
            },
            kodami_inarticle: {
                placementId: 'E3FA868D',
                gpid: '/1010633/kodami_inarticle'
            },
            kodami_low: {
                placementId: 'E3FA868D',
                gpid: '/1010633/kodami_low'
            },
            kodami_top: {
                placementId: 'E3FA868D',
                gpid: '/1010633/kodami_top'
            },
        },
    },
    taboola: {
        display: {
            //kodami_overlayer: {
            //    publisherId: '1816501',
            //},
            fpmobile_300x250: {
                publisherId: '1816501',
            },
            fpmobile_300x250_top: {
                publisherId: '1816501',
            },
            fpmobile_leadeboard: {
                publisherId: '1816501',
            },
            //inarticle
            fanpage_inarticle: {
                publisherId: '1816501',
            },
            cookist_it_inarticle: {
                publisherId: '1816509',
            },
            geopop_inarticle: {
                publisherId: '1816505',
            },
            fpmobile_fplayer: {
                publisherId: '1816501',
            },
            fpmobile_fplayer2: {
                publisherId: '1816501',
            },
            fpmobile_fplayer3: {
                publisherId: '1816501',
            },
            fpmobile_fplayer4: {
                publisherId: '1816501',
            },
            ck_it_mobile_fplayer2: {
                publisherId: '1816509',
            },
            ck_it_mobile_fplayer3: {
                publisherId: '1816509',
            },
            ck_it_mobile_fplayer4: {
                publisherId: '1816509',
            },
            ck_it_mobile_300x250_bottom: {
                publisherId: '1816509',
            },
            geopop_fplayer: {
                publisherId: '1816505',
            },
            geopop_fplayer2: {
                publisherId: '1816505',
            },
            geopop_fplayer3: {
                publisherId: '1816505',
            },
            geopop_fplayer4: {
                publisherId: '1816505',
            },
            geopop_bottom: {
                publisherId: '1816505',
            },
            ckmobile_300x250: {
                publisherId: '1816509',
            },
            ckmobile_300x250_bottom: {
                publisherId: '1816509',
            },
            ckmobile_300x250_top: {
                publisherId: '1816509',
            },
            ckmobile_fplayer: {
                publisherId: '1838467',
            },
            ckmobile_leaderboard: {
                publisherId: '1838467',
            },
            cookist_mobile_300x250_bottom: {
                publisherId: '1838467',
            },
            cookist_mobile_300x250: {
                publisherId: '1838467',
            },
            cookist_mobile_leaderboard: {
                publisherId: '1838467',
            },
            ck_it_mobile_300x250: {
                publisherId: '1816509',
            },
            ck_it_mobile_300x250_top: {
                publisherId: '1816509',
            },
            ck_it_mobile_fplayer: {
                publisherId: '1816509',
            },
            ck_it_mobile_leadeboard: {
                publisherId: '1816509',
            },
            cookist_it_mobile_300x250: {
                publisherId: '1816509',
            },
            cookist_it_mobile_300x250_bottom: {
                publisherId: '1816509',
            },
            cookist_it_mobile_leaderboard: {
                publisherId: '1816509',
            },
            geopop_leaderboard: {
                publisherId: '1816505',
            },
            geopop_middle: {
                publisherId: '1816505',
            },
            geopop_top: {
                publisherId: '1816505',
            },


        }
    },
    improve: {
        video: {
            fanpage_video: {
                placementId: 23319251,
                publisherId: 1993
            },
            ck_it_video: {
                placementId: 23319278,
                publisherId: 1993
            },
            ck_wow_video: {
                placementId: 23319278,
                publisherId: 1993
            },
            ck_legal_video: {
                placementId: 23319278,
                publisherId: 1993
            },
            geopop_video: {
                placementId: 23319279,
                publisherId: 1993
            },
        }
    },
    rubicon: {
        display: {
            //inarticle
            fanpage_inarticle: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            cookist_it_inarticle: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            geopop_inarticle: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            //  fanpage
            fpmobile_leadeboard: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            fpmobile_300x250_top: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            fpmobile_300x250: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            fpmobile_fplayer: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            fpmobile_300x250_bottom: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            //  cookstit
            ck_it_mobile_leadeboard: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_300x250_top: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_300x250: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_fplayer: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_fplayer2: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_fplayer3: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_fplayer4: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_300x250_bottom: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            //  Ohga
            ohga_header: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            ohga_300x250_top: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            ohga_300x250_middle: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            ohga_low: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            ohga_bottom: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            //  Geopop
            geopop_leaderboard: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_top: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_middle: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_fplayer: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_fplayer2: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_fplayer3: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_fplayer4: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_bottom: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            //  cookistcom
            ckmobile_leaderboard: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            ckmobile_300x250_top: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            ckmobile_300x250: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            ckmobile_fplayer: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            ckmobile_300x250_bottom: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            //  Kodami
            //kodami_overlayer: {
            //    accountId: 12546,
            //    siteId: 583266,
            //    zoneId: 3724770,
            //},
            kodami_header: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            kodami_top: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            kodami_middle: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            kodami_low: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            kodami_bottom: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
        },
        video: {
            fanpage_video: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724772,
            },
            ck_it_video: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724778,
            },
            ck_wow_video: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724796,
            },
            ck_legal_video: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724796,
            },
            ohga_video: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724804,
            },
            kodami_video: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724772,
            },
            geopop_video: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            wamily_video: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724772,
            },
            lexplain_video: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724772,
            },

        }
    },
    pubmatic_apex: {
        display: {
            //  fanpage
            fpmobile_leadeboard: {
                publisherId: '161546',
                adSlot: '6739111',
            },
            fpmobile_300x250_top: {
                publisherId: '161546',
                adSlot: '6739112',
            },
            fpmobile_300x250: {
                publisherId: '161546',
                adSlot: '6739113',
            },
            fpmobile_fplayer: {
                publisherId: '161546',
                adSlot: '6739114',
            },
            fpmobile_300x250_bottom: {
                publisherId: '161546',
                adSlot: '6739115',
            },
            //  cookstit
            ck_it_mobile_leadeboard: {
                publisherId: '161546',
                adSlot: '6739116',
            },
            ck_it_mobile_300x250_top: {
                publisherId: '161546',
                adSlot: '6739117',
            },
            ck_it_mobile_300x250: {
                publisherId: '161546',
                adSlot: '6739118',
            },
            ck_it_mobile_fplayer: {
                publisherId: '161546',
                adSlot: '6739119',
            },
            ck_it_mobile_fplayer2: {
                publisherId: '161546',
                adSlot: '6739120',
            },
            ck_it_mobile_fplayer3: {
                publisherId: '161546',
                adSlot: '6739121',
            },
            ck_it_mobile_fplayer4: {
                publisherId: '161546',
                adSlot: '6739122',
            },
            ck_it_mobile_300x250_bottom: {
                publisherId: '161546',
                adSlot: '6739123',
            },
            //  Ohga
            ohga_header: {
                publisherId: '161546',
                adSlot: '6739124',
            },
            ohga_300x250_top: {
                publisherId: '161546',
                adSlot: '6739125',
            },
            ohga_300x250_middle: {
                publisherId: '161546',
                adSlot: '6739126',
            },
            ohga_low: {
                publisherId: '161546',
                adSlot: '6739127',
            },
            ohga_bottom: {
                publisherId: '161546',
                adSlot: '6739128',
            },
            //  Geopop
            geopop_leaderboard: {
                publisherId: '161546',
                adSlot: '6739129',
            },
            geopop_top: {
                publisherId: '161546',
                adSlot: '6739130',
            },
            geopop_middle: {
                publisherId: '161546',
                adSlot: '6739131',
            },
            geopop_fplayer: {
                publisherId: '161546',
                adSlot: '6739132',
            },

            geopop_fplayer2: {
                publisherId: '161546',
                adSlot: '6739133',
            },

            geopop_fplayer3: {
                publisherId: '161546',
                adSlot: '6739134',
            },

            geopop_fplayer4: {
                publisherId: '161546',
                adSlot: '6739135',
            },
            geopop_bottom: {
                publisherId: '161546',
                adSlot: '6739136',
            },
            //  cookistcom
            ckmobile_leaderboard: {
                publisherId: '161546',
                adSlot: '6739137',
            },
            ckmobile_300x250_top: {
                publisherId: '161546',
                adSlot: '6739138',
            },
            ckmobile_300x250: {
                publisherId: '161546',
                adSlot: '6739139',
            },
            ckmobile_fplayer: {
                publisherId: '161546',
                adSlot: '6739140',
            },
            ckmobile_300x250_bottom: {
                publisherId: '161546',
                adSlot: '6739141',
            },
            //  Kodami
            kodami_header: {
                publisherId: '161546',
                adSlot: '6739142',
            },
            kodami_top: {
                publisherId: '161546',
                adSlot: '6739143',
            },
            kodami_middle: {
                publisherId: '161546',
                adSlot: '6739144',
            },
            kodami_low: {
                publisherId: '161546',
                adSlot: '6739145',
            },
            kodami_bottom: {
                publisherId: '161546',
                adSlot: '6739146    ',
            },
        },
        video: {
            fanpage_video: {
                publisherId: '161546',
                adSlot: '6739147',
            },
            ck_it_video: {
                publisherId: '161546',
                adSlot: '6739150',
            },
            ck_wow_video: {
                publisherId: '161546',
                adSlot: '6739158',
            },
            ck_legal_video: {
                publisherId: '161546',
                adSlot: '6739147',
            },
            ohga_video: {
                publisherId: '161546',
                adSlot: '6739153',
            },
            kodami_video: {
                publisherId: '161546',
                adSlot: '6739161',
            },
            geopop_video: {
                publisherId: '161546',
                adSlot: '6739155',
            },
            wamily_video: {
                publisherId: '161546',
                adSlot: '6739147',
            },
            lexplain_video: {
                publisherId: '161546',
                adSlot: '6739147',
            },

        }
    },
    criteo: {
        display: {
            //  Kodami
            kodami_header: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_header',
                pbadslot: '/1010633/kodami_header'
            },
            kodami_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_top',
                pbadslot: '/1010633/kodami_top'
            },
            kodami_middle: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_middle',
                pbadslot: '/1010633/kodami_middle'
            },
            kodami_low: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_low',
                pbadslot: '/1010633/kodami_low'
            },
            kodami_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_bottom',
                pbadslot: '/1010633/kodami_bottom'
            },
            //fanpage
            fpmobile_300x250: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_300x250',
                pbadslot: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_300x250_top',
                pbadslot: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_leadeboard: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_leadeboard',
                pbadslot: '/1010633/fpmobile_leadeboard'
            },
            fpmobile_fplayer: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_fplayer',
                pbadslot: '/1010633/fpmobile_fplayer'
            },
            fpmobile_300x250_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_300x250_bottom',
                pbadslot: '/1010633/fpmobile_300x250_bottom'
            },
            //cookistit
            ck_it_mobile_300x250: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_300x250',
                pbadslot: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_300x250_top',
                pbadslot: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_fplayer',
                pbadslot: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_leadeboard',
                pbadslot: '/1010633/ck_it_mobile_leadeboard'
            },
            ck_it_mobile_fplayer2: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_fplayer',
                pbadslot: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer3: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_fplayer',
                pbadslot: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer4: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_fplayer',
                pbadslot: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_300x250_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_300x250_bottom',
                pbadslot: '/1010633/ck_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_300x250: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookist_it_mobile_300x250',
                pbadslot: '/1010633/cookist_it_mobile_300x250'
            },
            cookist_it_mobile_300x250_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookist_it_mobile_300x250_bottom',
                pbadslot: '/1010633/cookist_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_leaderboard: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_leadeboard',
                pbadslot: '/1010633/ck_it_mobile_leadeboard'
            },
            //geopop
            geopop_leaderboard: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_leaderboard',
                pbadslot: '/1010633/geopop_leaderboard'
            },
            geopop_middle: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_middle',
                pbadslot: '/1010633/geopop_middle'
            },
            geopop_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_top',
                pbadslot: '/1010633/geopop_top'
            },
            geopop_fplayer: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_fplayer',
                pbadslot: '/1010633/geopop_fplayer'
            },
            geopop_fplayer2: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_fplayer/geopop_fplayer2',
                pbadslot: '/1010633/geopop_fplayer/geopop_fplayer2'
            },
            geopop_fplayer3: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_fplayer/geopop_fplayer3',
                pbadslot: '/1010633/geopop_fplayer/geopop_fplayer3'
            },
            geopop_fplayer4: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_fplayer/geopop_fplayer4',
                pbadslot: '/1010633/geopop_fplayer/geopop_fplayer4'
            },
            geopop_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_bottom',
                pbadslot: '/1010633/geopop_bottom'
            },
            //cookistcom
            ckmobile_300x250: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ckmobile_300x250',
                pbadslot: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ckmobile_300x250_bottom',
                pbadslot: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_300x250_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ckmobile_300x250_top',
                pbadslot: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_fplayer: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ckmobile_fplayer',
                pbadslot: '/1010633/ckmobile_fplayer'
            },
        },
        video: {
            fanpage_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fanpage/video',
                pbadslot: '/1010633/fanpage/video'
            },
            ck_it_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookistit/video',
                pbadslot: '/1010633/cookistit/video'
            },
            ck_wow_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookistcom/video',
                pbadslot: '/1010633/cookistcom/video'
            },
            ck_legal_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookistlegal/video',
                pbadslot: '/1010633/cookistlegal/video'
            },
            ohga_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ohga/video',
                pbadslot: '/1010633/ohga/video'
            },
            kodami_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami/video',
                pbadslot: '/1010633/kodami/video'
            },
            geopop_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop/video',
                pbadslot: '/1010633/geopop/video'
            },
            wamily_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/wamily/video',
                pbadslot: '/1010633/wamily/video'
            },
            lexplain_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/lexplain/video',
                pbadslot: '/1010633/lexplain/video'
            },
        }
    },
    ix: {
        display: {
            //  Kodami
            kodami_header: {
                siteId: '1106633',
                gpid: '/1010633/kodami_header' //tu che leggi ti chiederai "a che cazz serv?": serve.
            },
            kodami_top: {
                siteId: '1106631',
                gpid: '/1010633/kodami_top'
            },
            kodami_middle: {
                siteId: '1106632',
                gpid: '/1010633/kodami_middle'
            },
            kodami_low: {
                siteId: '1106634',
                gpid: '/1010633/kodami_low'
            },
            kodami_bottom: {
                siteId: '1106635',
                gpid: '/1010633/kodami_bottom'
            },
            //fanpage
            fpmobile_300x250: {
                siteId: '1106608',
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_top: {
                siteId: '1106607',
                gpid: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_leadeboard: {
                siteId: '1106609',
                gpid: '/1010633/fpmobile_leadeboard'
            },
            fpmobile_fplayer: {
                siteId: '1106610',
                gpid: '/1010633/fpmobile_fplayer'
            },
            fpmobile_300x250_bottom: {
                siteId: '1106611',
                gpid: '/1010633/fpmobile_300x250_bottom'
            },
            //cookistit
            ck_it_mobile_300x250: {
                siteId: '1106614',
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_top: {
                siteId: '1106613',
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                siteId: '1106616',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                siteId: '1106615',
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            ck_it_mobile_fplayer2: {
                siteId: '1106615',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer3: {
                siteId: '1106615',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer4: {
                siteId: '1106615',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_300x250_bottom: {
                siteId: '1106617',
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_300x250: {
                siteId: '1195754',
                gpid: '/1010633/cookist_it_mobile_300x250'
            },
            cookist_it_mobile_300x250_bottom: {
                siteId: '1195756',
                gpid: '/1010633/cookist_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_leaderboard: {
                siteId: '1195757',
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            //geopop
            geopop_leaderboard: {
                siteId: '1047800',
                gpid: '/1010633/geopop_leaderboard'
            },
            geopop_middle: {
                siteId: '1047798',
                gpid: '/1010633/geopop_middle'
            },
            geopop_top: {
                siteId: '1047797',
                gpid: '/1010633/geopop_top'
            },
            geopop_fplayer: {
                siteId: '1047799',
                gpid: '/1010633/geopop_fplayer'
            },
            geopop_fplayer2: {
                siteId: '1047799',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer2'
            },
            geopop_fplayer3: {
                siteId: '1047799',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer3'
            },
            geopop_fplayer4: {
                siteId: '1047799',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer4'
            },
            geopop_bottom: {
                siteId: '1047801',
                gpid: '/1010633/geopop_bottom'
            },
            //cookistcom
            ckmobile_300x250: {
                siteId: '1047801',
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_bottom: {
                siteId: '1047801',
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_300x250_top: {
                siteId: '1047801',
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_fplayer: {
                siteId: '1047801',
                gpid: '/1010633/ckmobile_fplayer'
            },
        },
        video: {
            fanpage_video: {
                siteId: '1106612',
                gpid: '/1010633/fanpage/video'
            },
            ck_it_video: {
                siteId: '1106618',
                gpid: '/1010633/cookistit/video'
            },
            ck_wow_video: {
                siteId: '1106624',
                gpid: '/1010633/cookistcom/video'
            },
            ck_legal_video: {
                siteId: '1106624',
                gpid: '/1010633/cookistlegal/video'
            },
            ohga_video: {
                siteId: '1106630',
                gpid: '/1010633/ohga/video'
            },
            kodami_video: {
                siteId: '1106636',
                gpid: '/1010633/kodami/video'
            },
            geopop_video: {
                siteId: '1047802',
                gpid: '/1010633/geopop/video'
            },
            wamily_video: {
                siteId: '1106612',
                gpid: '/1010633/wamily/video'
            },
            lexplain_video: {
                siteId: '1047808',
                gpid: '/1010633/lexplain/video'
            },
        }
    },
    ogury: {
        display: {
            // fanpage.it
            fpmobile_300x250: {
                assetKey: 'OGY-BCCBF11AEA48',
                adUnitId: 'wm-hb-stdb-fanpag-ciaop-4bcaceqv7bxi',
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_bottom: {
                assetKey: 'OGY-BCCBF11AEA48',
                //adUnitId: 'wm-hb-stdb-fanpag-ciaop-t5ibzbmq389q',
                adUnitId: 'wm-hb-iart-fanpag-ciaop-4jkgmplmztwy',
                gpid: '/1010633/pmobile_300x250_bottom'
            },
            fpmobile_fplayer: {
                assetKey: 'OGY-BCCBF11AEA48',
                adUnitId: 'wm-hb-stdb-fanpag-ciaop-0xtdyl2zjz9g',
                gpid: '/1010633/fpmobile_fplayer'
            },
            fpmobile_300x250_top: {
                assetKey: 'OGY-BCCBF11AEA48',
                adUnitId: 'wm-hb-stdb-fanpag-ciaop-a71zr0db0uv0',
                gpid: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_leaderboard: {
                assetKey: 'OGY-BCCBF11AEA48',
                adUnitId: 'wm-hb-stdb-fanpag-ciaop-zrk8qi6lnmsv',
                gpid: '/1010633/fpmobile_leaderboard'
            },
            fanpage_inarticle: {
                assetKey: 'OGY-BCCBF11AEA48',
                adUnitId: 'wm-hb-stdb-fanpag-ciaop-7huxp6v4jfed',
                gpid: '/1010633/fanpage_inarticle'
            },

            // cookist.it
            ck_it_mobile_300x250: {
                assetKey: 'OGY-90CD324234B1',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-jpw2ihcsalhx',
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_bottom: {
                assetKey: 'OGY-90CD324234B1',
                //adUnitId: 'wm-hb-stdb-cookis-ciaop-sysijvgw0uft',
                adUnitid: 'wm-hb-iart-cookis-ciaop-bm7mpunewr0y',
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            ck_it_mobile_300x250_top: {
                assetKey: 'OGY-90CD324234B1',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-vteoyitzpdos',
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                assetKey: 'OGY-90CD324234B1',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-24ileikwtkii',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                assetKey: 'OGY-90CD324234B1',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-21qvhwpfvldr',
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            cookist_it_inarticle: {
                assetKey: 'OGY-90CD324234B1',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-bpcq6xfzhbn8',
                gpid: '/1010633/cookist_it_inarticle'
            },

            // ohga.it
            ohga_300x250_middle: {
                assetKey: 'OGY-80DDD5B1EE4A',
                adUnitId: 'wm-hb-stdb-ohga-ciaop-hd5nz9k2qecbuw',
                gpid: '/1010633/ohga_300x250_middle'
            },
            ohga_300x250_top: {
                assetKey: 'OGY-80DDD5B1EE4A',
                adUnitId: 'wm-hb-stdb-ohga-ciaop-gbj3ko0sxtbxmx',
                gpid: '/1010633/ohga_300x250_top'
            },
            ohga_bottom: {
                assetKey: 'OGY-80DDD5B1EE4A',
                //adUnitId: 'wm-hb-stdb-ohga-ciaop-v1k4faqxaohlay',
                adUnitId: 'wm-hb-iart-ohga-ciaop-mf8jmjykbdaofh',
                gpid: '/1010633/ohga_bottom'
            },
            ohga_header: {
                assetKey: 'OGY-80DDD5B1EE4A',
                adUnitId: 'wm-hb-stdb-ohga-ciaop-ijgzhfuq0wzlbu',
                gpid: '/1010633/ohga_header'
            },
            // cookistcom
            ckmobile_leaderboard: {
                assetKey: 'OGY-E2E75C934F08',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-q32jbs8vybun',
                gpid: '/1010633/ckmobile_leaderboard'
            },
            ckmobile_300x250: {
                assetKey: 'OGY-E2E75C934F08',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-szncsuqfvqrq',
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_bottom: {
                assetKey: 'OGY-E2E75C934F08',
                //adUnitId: 'wm-hb-stdb-cookis-ciaop-atdd9vdgkl1w',
                adUnitId: 'wm-hb-iart-cookis-ciaop-edef7kkiskjj',
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_300x250_top: {
                assetKey: 'OGY-E2E75C934F08',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-gk7bia1sqjk9',
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_fplayer: {
                assetKey: 'OGY-E2E75C934F08',
                adUnitId: 'wm-hb-stdb-cookis-ciaop-cwpbeyhmfapz',
                gpid: '/1010633/ckmobile_fplayer'
            },
            // geopop.it
            geopop_top: {
                assetKey: 'OGY-525961E33587',
                adUnitId: 'wm-hb-stdb-geopop-ciaop-qo2gikzxzevt',
                gpid: '/1010633/geopop_top'
            },
            geopop_middle: {
                assetKey: 'OGY-525961E33587',
                adUnitId: 'wm-hb-stdb-geopop-ciaop-h3v8liv6sle4',
                gpid: '/1010633/geopop_middle'
            },
            geopop_bottom: {
                assetKey: 'OGY-525961E33587',
                //adUnitId: 'wm-hb-stdb-geopop-ciaop-basiodus6zqn',
                adUnitId: 'wm-hb-iart-geopop-ciaop-nczdlanq6iao',
                gpid: '/1010633/geopop_bottom'
            },
            geopop_leaderboard: {
                assetKey: 'OGY-525961E33587',
                adUnitId: 'wm-hb-stdb-geopop-ciaop-6byvhmrraqdp',
                gpid: '/1010633/geopop_leaderboard'
            },
            geopop_fplayer: {
                assetKey: 'OGY-525961E33587',
                adUnitId: 'wm-hb-stdb-geopop-ciaop-memyjv7yc6a0',
                gpid: '/1010633/geopop_fplayer'
            },
            geopop_inarticle: {
                assetKey: 'OGY-525961E33587',
                adUnitId: 'wm-hb-stdb-geopop-ciaop-m8jvmwghurq1',
                gpid: '/1010633/geopop_inarticle'
            }
        },
    },
    seedtag: {
        display: {
            go_interstitial: {
                publisherId: '1044-6008-01',
                adUnitId: '37209542',
                placement: 'inTerstitial',
                gpid: '/1010633/go_interstitial'
            },
            // Kodami
            kodami_header: {
                publisherId: '8274-3016-01',
                adUnitId: '35406507',
                placement: 'inBanner',
                gpid: '/1010633/kodami_header'
            },
            kodami_top: {
                publisherId: '8274-3016-01',
                adUnitId: '35406643',
                placement: 'inArticle',
                gpid: '/1010633/kodami_top'
            },
            kodami_middle: {
                publisherId: '8274-3016-01',
                adUnitId: '35406642',
                placement: 'inArticle',
                gpid: '/1010633/kodami_middle'
            },
            kodami_low: {
                publisherId: '8274-3016-01',
                adUnitId: '35406641',
                placement: 'inArticle',
                gpid: '/1010633/kodami_low'
            },
            kodami_bottom: {
                publisherId: '8274-3016-01',
                adUnitId: '35406506',
                placement: 'inArticle',
                gpid: '/1010633/kodami_bottom'
            },
            // fanpage
            fpmobile_300x250: {
                publisherId: '1044-6008-01',
                adUnitId: '35406650',
                placement: 'inArticle',
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_top: {
                publisherId: '1044-6008-01',
                adUnitId: '36570985',
                placement: 'inBanner',
                gpid: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_leadeboard: {
                publisherId: '1044-6008-01',
                adUnitId: '35406441',
                placement: 'inBanner',
                gpid: '/1010633/fpmobile_leadeboard'
            },
            fpmobile_fplayer: {
                publisherId: '1044-6008-01',
                adUnitId: '35406652',
                placement: 'inBanner',
                gpid: '/1010633/fpmobile_fplayer'
            },
            fpmobile_300x250_bottom: {
                publisherId: '1044-6008-01',
                adUnitId: '35406440',
                placement: 'inBanner',
                gpid: '/1010633/fpmobile_300x250_bottom'
            },
            // cookistit
            ck_it_mobile_300x250: {
                publisherId: '3396-5388-01',
                adUnitId: '35406635',
                placement: 'inArticle',
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_top: {
                publisherId: '3396-5388-01',
                adUnitId: '35406636',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                publisherId: '3396-5388-01',
                adUnitId: '35406637',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            ck_it_mobile_fplayer2: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_fplayer2'
            },
            ck_it_mobile_fplayer3: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_fplayer3'
            },
            ck_it_mobile_fplayer4: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_fplayer4'
            },
            ck_it_mobile_300x250_bottom: {
                publisherId: '3396-5388-01',
                adUnitId: '35406469',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_300x250: {
                publisherId: '3396-5388-01',
                adUnitId: '35406635',
                placement: 'inArticle',
                gpid: '/1010633/cookist_it_mobile_300x250'
            },
            cookist_it_mobile_300x250_bottom: {
                publisherId: '3396-5388-01',
                adUnitId: '35406469',
                placement: 'inBanner',
                gpid: '/1010633/cookist_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_leaderboard: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/cookist_it_mobile_leaderboard'
            },
            // geopop
            geopop_leaderboard: {
                publisherId: '2008-0806-01',
                adUnitId: '35406645',
                placement: 'inBanner',
                gpid: '/1010633/geopop_leaderboard'
            },
            geopop_middle: {
                publisherId: '2008-0806-01',
                adUnitId: '35406647',
                placement: 'inBanner',
                gpid: '/1010633/geopop_middle'
            },
            geopop_top: {
                publisherId: '2008-0806-01',
                adUnitId: '35406648',
                placement: 'inBanner',
                gpid: '/1010633/geopop_top'
            },
            geopop_fplayer: {
                publisherId: '2008-0806-01',
                adUnitId: '35406646',
                placement: 'inArticle',
                gpid: '/1010633/geopop_fplayer'
            },
            geopop_fplayer2: {
                publisherId: '2008-0806-01',
                adUnitId: '35406646',
                placement: 'inArticle',
                gpid: '/1010633/geopop_fplayer2'
            },
            geopop_fplayer3: {
                publisherId: '2008-0806-01',
                adUnitId: '35406646',
                placement: 'inArticle',
                gpid: '/1010633/geopop_fplayer3'
            },
            geopop_fplayer4: {
                publisherId: '2008-0806-01',
                adUnitId: '35406646',
                placement: 'inArticle',
                gpid: '/1010633/geopop_fplayer4'
            },
            geopop_bottom: {
                publisherId: '2008-0806-01',
                adUnitId: '35406644',
                placement: 'inBanner',
                gpid: '/1010633/geopop_bottom'
            },
            // cookistcom
            ckmobile_300x250: {
                publisherId: '4258-6544-01',
                adUnitId: '35406626',
                placement: 'inArticle',
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_bottom: {
                publisherId: '4258-6544-01',
                adUnitId: '35406630',
                placement: 'inBanner',
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_300x250_top: {
                publisherId: '4258-6544-01',
                adUnitId: '35406628',
                placement: 'inArticle',
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_fplayer: {
                publisherId: '4258-6544-01',
                adUnitId: '35406629',
                placement: 'inArticle',
                gpid: '/1010633/ckmobile_fplayer'
            },
        },
        video: {
            fanpage_video: {
                publisherId: '1044-6008-01',
                adUnitId: '35406438',
                placement: 'inStream',
                gpid: '/1010633/fanpage_video'
            },
            ck_it_video: {
                publisherId: '3396-5388-01',
                adUnitId: '35406608',
                placement: 'inStream',
                gpid: '/1010633/ck_it_video'
            },
            ck_wow_video: {
                publisherId: '4258-6544-01',
                adUnitId: '35406601',
                placement: 'inStream',
                gpid: '/1010633/ck_wow_video'
            },
            ck_legal_video: {
                publisherId: '4258-6544-01',
                adUnitId: '35406601',
                placement: 'inStream',
                gpid: '/1010633/ck_legal_video'
            },
            ohga_video: {
                publisherId: '1044-6008-01',
                adUnitId: '35406438',
                placement: 'inStream',
                gpid: '/1010633/ohga_video'
            },
            kodami_video: {
                publisherId: '8274-3016-01',
                adUnitId: '35406527',
                placement: 'inStream',
                gpid: '/1010633/kodami_video'
            },
            geopop_video: {
                publisherId: '2008-0806-01',
                adUnitId: '35406523',
                placement: 'inStream',
                gpid: '/1010633/geopop_video'
            },
            wamily_video: {
                publisherId: '1044-6008-01',
                adUnitId: '35406438',
                placement: 'inStream',
                gpid: '/1010633/wamily_video'
            },
            lexplain_video: {
                publisherId: '1044-6008-01',
                adUnitId: '35406438',
                placement: 'inStream',
                gpid: '/1010633/lexplain_video'
            }
        }
    },
    pubmatic: {
        display: {
            //  inarticle
            fanpage_inarticle: {
                publisherId: '161182',
                adSlot: '6787215',
            },
            cookist_it_inarticle: {
                publisherId: '161182',
                adSlot: '6787250',
            },
            geopop_inarticle: {
                publisherId: '161182',
                adSlot: '6787275',
            },
            //  fanpage
            fpmobile_leadeboard: {
                publisherId: '161182',
                adSlot: '6629965',
            },
            fpmobile_300x250_top: {
                publisherId: '161182',
                adSlot: '6629966',
            },
            fpmobile_300x250: {
                publisherId: '161182',
                adSlot: '6629967',
            },
            fpmobile_fplayer: {
                publisherId: '161182',
                adSlot: '6629968',
            },
            fpmobile_300x250_bottom: {
                publisherId: '161182',
                adSlot: '6629969',
            },
            //  cookstit
            ck_it_mobile_leadeboard: {
                publisherId: '161182',
                adSlot: '6629970',
            },
            ck_it_mobile_300x250_top: {
                publisherId: '161182',
                adSlot: '6629971',
            },
            ck_it_mobile_300x250: {
                publisherId: '161182',
                adSlot: '6629972',
            },
            ck_it_mobile_fplayer: {
                publisherId: '161182',
                adSlot: '6629973',
            },
            ck_it_mobile_fplayer2: {
                publisherId: '161182',
                adSlot: '6629974',
            },
            ck_it_mobile_fplayer3: {
                publisherId: '161182',
                adSlot: '6629975',
            },
            ck_it_mobile_fplayer4: {
                publisherId: '161182',
                adSlot: '6629976',
            },
            ck_it_mobile_300x250_bottom: {
                publisherId: '161182',
                adSlot: '6629977',
            },
            //  Ohga
            ohga_header: {
                publisherId: '161182',
                adSlot: '6629978',
            },
            ohga_300x250_top: {
                publisherId: '161182',
                adSlot: '6629979',
            },
            ohga_300x250_middle: {
                publisherId: '161182',
                adSlot: '6629980',
            },
            ohga_low: {
                publisherId: '161182',
                adSlot: '6629981',
            },
            ohga_bottom: {
                publisherId: '161182',
                adSlot: '6629982',
            },
            //  Geopop
            geopop_leaderboard: {
                publisherId: '161182',
                adSlot: '6629983',
            },
            geopop_top: {
                publisherId: '161182',
                adSlot: '6629984',
            },
            geopop_middle: {
                publisherId: '161182',
                adSlot: '6629985',
            },
            geopop_fplayer: {
                publisherId: '161182',
                adSlot: '6629986',
            },

            geopop_fplayer2: {
                publisherId: '161182',
                adSlot: '6629987',
            },

            geopop_fplayer3: {
                publisherId: '161182',
                adSlot: '6629988',
            },

            geopop_fplayer4: {
                publisherId: '161182',
                adSlot: '6629989',
            },
            geopop_bottom: {
                publisherId: '161182',
                adSlot: '6629990',
            },
            //  cookistcom
            ckmobile_leaderboard: {
                publisherId: '161182',
                adSlot: '6629991',
            },
            ckmobile_300x250_top: {
                publisherId: '161182',
                adSlot: '6629992',
            },
            ckmobile_300x250: {
                publisherId: '161182',
                adSlot: '6629993',
            },
            ckmobile_fplayer: {
                publisherId: '161182',
                adSlot: '6629994',
            },
            ckmobile_300x250_bottom: {
                publisherId: '161182',
                adSlot: '6629995',
            },
            //  Kodami
            kodami_header: {
                publisherId: '161182',
                adSlot: '6629996',
            },
            kodami_top: {
                publisherId: '161182',
                adSlot: '6629997',
            },
            kodami_middle: {
                publisherId: '161182',
                adSlot: '6629998',
            },
            kodami_low: {
                publisherId: '161182',
                adSlot: '6629999',
            },
            kodami_bottom: {
                publisherId: '161182',
                adSlot: '6630000',
            },
        },
        video: {
            fanpage_video: {
                publisherId: '161182',
                adSlot: '6790502',
            },
            ck_it_video: {
                publisherId: '161182',
                adSlot: '6790505',
            },
            ck_wow_video: {
                publisherId: '161182',
                adSlot: '6790513',
            },
            ck_legal_video: {
                publisherId: '161182',
                adSlot: '6790513',
            },
            ohga_video: {
                publisherId: '161182',
                adSlot: '6790508',
            },
            kodami_video: {
                publisherId: '161182',
                adSlot: '6790516',
            },
            geopop_video: {
                publisherId: '161182',
                adSlot: '6790510',
            },
            wamily_video: {
                publisherId: '161182',
                adSlot: '6790502',
            },
            lexplain_video: {
                publisherId: '161182',
                adSlot: '6790502',
            },

        }
    }
}